import { observable, computed, makeObservable } from "mobx";
import { Breakpoint } from "../utils/Breakpoints";
import throttle from "lodash/throttle";

export default class BreakpointStore {
  @observable current: string = Breakpoint();

  @computed
  get isMobile(): boolean {
    return this.current === "xxs" || this.current === "xs" || this.current === "sm";
  }

  @computed
  get isTinyMobile(): boolean {
    return  this.current === "xxs";
  }

  constructor() {
    makeObservable(this);
    window.addEventListener(
      "resize",
      throttle(() => {
        this.current = Breakpoint();
      }, 300)
    );
  }
}
